

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <ImagenesBase></ImagenesBase>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import ImagenesBase from '@/components/base/ImagenesBase.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    ImagenesBase
    
  },

  methods: {

}

}
    

</script>


